module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "feedback-editor"
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.header))])]), _c('div', {
    staticClass: "field is-horizontal"
  }, [(_vm.languages) ? _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.language),
      expression: "language"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.language = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_none']))]), _vm._l((_vm.languages), function(lang) {
    return _c('option', {
      domProps: {
        "value": lang
      }
    }, [_vm._v(_vm._s(lang))])
  })], 2)]) : _c('bulma-checkbox', {
    attrs: {
      "label": _vm.tokens['lbl_enabled']
    },
    model: {
      value: (_vm.enabled),
      callback: function($$v) {
        _vm.enabled = $$v
      },
      expression: "enabled"
    }
  }), _vm._t("first")], 2), _c('div', {
    staticClass: "field is-horizontal"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thresholdIsSmart),
      expression: "thresholdIsSmart"
    }],
    attrs: {
      "disabled": !_vm.isEnabled || !_vm.hasThresholdOptions
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.thresholdIsSmart = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_fixed']))]), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.tokens['item_calib']))])])]), (_vm.thresholdIsSmart) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.thresholdMin),
      expression: "thresholdMin",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "100",
      "disabled": !_vm.canEditCalibThresholdParams,
      "min": "1000",
      "max": _vm.thresholdMax
    },
    domProps: {
      "value": (_vm.thresholdMin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thresholdMin = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "control-line"
  }, [_vm._v("-")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.thresholdMax),
      expression: "thresholdMax",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "100",
      "disabled": !_vm.canEditCalibThresholdParams,
      "max": "5000",
      "min": _vm.thresholdMin
    },
    domProps: {
      "value": (_vm.thresholdMax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thresholdMax = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "control-line"
  }, [_vm._v("ms")])] : [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.thresholdValue),
      expression: "thresholdValue",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "step": "100",
      "disabled": !_vm.isEnabled
    },
    domProps: {
      "value": (_vm.thresholdValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thresholdValue = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "control-line"
  }, [_vm._v("ms")])], _vm._t("second")], 2), _c('div', {
    staticClass: "field is-horizontal"
  }, [_vm._t("default")], 2), _c('p')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec8f61e6"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/feedbackEditor.vue
// module id = 450
// module chunks = 0